var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageDnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.9993 8.33333H25.4993C23.2892 8.33333 21.1696 9.21131 19.6068 10.7741C18.044 12.3369 17.166 14.4565 17.166 16.6667V83.3333C17.166 85.5435 18.044 87.6631 19.6068 89.2259C21.1696 90.7887 23.2892 91.6667 25.4993 91.6667H75.4993C77.7095 91.6667 79.8291 90.7887 81.3919 89.2259C82.9547 87.6631 83.8327 85.5435 83.8327 83.3333V29.1667L62.9993 8.33333Z",
    stroke: "#2A2A2A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.834 8.33333V25C58.834 27.2101 59.712 29.3298 61.2748 30.8926C62.8376 32.4554 64.9572 33.3333 67.1673 33.3333H83.834",
    stroke: "#2A2A2A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1673 58.3333C46.7697 58.3333 50.5006 54.6024 50.5006 50C50.5006 45.3976 46.7697 41.6667 42.1673 41.6667C37.5649 41.6667 33.834 45.3976 33.834 50C33.834 54.6024 37.5649 58.3333 42.1673 58.3333Z",
    stroke: "#2A2A2A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8333 70.8333L78.4333 65.4333C76.5502 63.5505 73.9963 62.4927 71.3333 62.4927C68.6704 62.4927 66.1165 63.5505 64.2333 65.4333L38 91.6667",
    stroke: "#2A2A2A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDnd);
export default __webpack_public_path__ + "static/media/image-dnd.e5380909241f3e18adf16e4064aecb2e.svg";
export { ForwardRef as ReactComponent };